import React, { useRef, useState } from "react";

import PageHeader from "../../../../molecules/PatientDetailsV2/PageHeader/PageHeader";
import DietPlansList from "../../../../molecules/DietV2/DietPlansList/DietPlansList";
import BottomSheet from "../../../../atoms/BottomSheet/BottomSheet";
import CreateDietPlan from "../../../../molecules/DietV2/CreateDietPlan/CreateDietPlan";
import DietPlanBuilder from "../../../../molecules/DietV2/CreateDietPlanV2/DietPlanBuilder";
import useCoachPermissions from "../../../../hooks/useCoachPermissions";
import Button from "../../../../atoms/Button/Button";

import { ReloadOutlined } from "@ant-design/icons";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import GROWTHBOOK from "../../../../constants/growthbookConstant";

const DietTaskPage: React.FC<any> = () => {
  const { canManageDiet } = useCoachPermissions();
  const dietPlanV2 = useFeatureIsOn(GROWTHBOOK.DIET_PLAN_V2);
  const [showBottomSheet, setShowBottomSheet] = useState(false);
  const [showCreateFlow, setShowCreateFlow] = useState(false);
  const [editDietPlan, setEditDietPlan] = useState<any>(null);
  const [copyDietPlan, setCopyDietPlan] = useState<any>(null);

  const dietPlansListRef = useRef<any>(null);

  const handleAddDietClick = () => {
    setEditDietPlan(null);
    setCopyDietPlan(null);
    if (dietPlanV2) {
      setShowCreateFlow(true);
    } else {
      setShowBottomSheet(true);
    }
  };

  const handleEditDietClick = (dietPlan: any) => {
    setCopyDietPlan(null);
    setEditDietPlan(dietPlan);
    if (dietPlanV2) {
      setShowCreateFlow(true);
    } else {
      setShowBottomSheet(true);
    }
  };

  const closeCreateFlow = () => {
    setShowCreateFlow(false);
    setEditDietPlan(null);
    setCopyDietPlan(null);
  };

  const handleCopyDietClick = (dietPlan: any) => {
    setEditDietPlan(null);
    setCopyDietPlan(dietPlan);
    if (dietPlanV2) {
      setShowCreateFlow(true);
    } else {
      setShowBottomSheet(true);
    }
  };

  const onSuccess = () => {
    setShowCreateFlow(false);
    setShowBottomSheet(false);
    setEditDietPlan(null);
    setCopyDietPlan(null);
    window.scrollTo(0, 0);
    dietPlansListRef?.current?.refresh();
  };

  return (
    <div className="diet-plan-page-container">
      <PageHeader
        title="List of Diet Plans"
        actions={
          <>
            <Button
              variant="outlined"
              title="Refresh"
              iconStart={<ReloadOutlined />}
              onClick={() => dietPlansListRef?.current?.refresh()}
            />
            {canManageDiet && (
              <Button onClick={handleAddDietClick}>+ Create Diet Plan</Button>
            )}
          </>
        }
      />

      <DietPlansList
        ref={dietPlansListRef}
        handleAddDietClick={handleAddDietClick}
        handleEditDietClick={handleEditDietClick}
        handleCopyDietClick={handleCopyDietClick}
      />

      {dietPlanV2 && showCreateFlow && (
        <DietPlanBuilder
          onCancel={closeCreateFlow}
          onSuccess={onSuccess}
          editDietPlan={editDietPlan}
          copyDietPlan={copyDietPlan}
        />
      )}

      {showBottomSheet && (
        <BottomSheet
          isOpen={showBottomSheet}
          title="Create Diet Plan"
          onClose={() => setShowBottomSheet(false)}
        >
          <CreateDietPlan
            onCancel={() => {
              setShowBottomSheet(false);
              setEditDietPlan(null);
            }}
            onSuccess={onSuccess}
            selectedDietPlan={editDietPlan || copyDietPlan}
            isEdit={!!editDietPlan}
            isCopy={!!copyDietPlan}
          />
        </BottomSheet>
      )}
    </div>
  );
};

export default DietTaskPage;
